import React, { useState, useEffect, useCallback, useMemo } from "react"
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from "@date-io/date-fns";
import { Box, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Link, TextField, Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import { DatePicker } from '@material-ui/pickers';
import Format from "date-fns/format";
import { useAuthUser } from "../../../hooks/useUserToken";
import { ReportingService } from "../../../utils/web_config_2";
import axios from 'axios';
import { LoadingScreen } from "../atoms/loading-card";

const useStyles = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		flexFlow: 1,
		[theme.breakpoints.up("sm")]: {
			marginLeft: 250,
		},
	},
}));

const TableView = ({ loading = false, data, date, maxTaps }) => {
	if (loading) return (
		<LoadingScreen />
	)

	return (
		<>
			<Card>
				<MUIDataTable
					title={
						<div>
							Date: {date.value} to {maxTaps}
						</div>
					}
					data={data}
					columns={[
						"Card Number",
						"Company Name",
						"Card Holder Name",
						"Tap Date",
						"Tap Location",
						"Total Taps",
					]}
					options={{
						filterType: "checkbox",
					}}
				/>
			</Card>
		</>
	)
}

export default function FraudulentCardTaps() {
	const [isLoading, setIsLoading] = useState(true);

	const styles = useStyles();

	const [showFilterDialog, setShowFilterDialog] = useState(false)
	const [reportLoad, setReportLoad] = useState(false)
	const [data, setData] = useState([])
	const [maxTaps, setMaxTaps] = useState(3);

	const [date, setDate] = useState({
		value: Format(new Date(), ["yyyy-MM-dd"]),
		error: "",
	});

	const { token } = useAuthUser();

	const filter_report = async () => {
		setIsLoading(true)
		if (!maxTaps) {
			alert("Max Types Required")
			setIsLoading(false)
			return;
		}

		setReportLoad(true)
		try {
			axios.defaults.baseURL = new ReportingService().BASE_URL;
			const reportInstance = axios.create(
				new ReportingService().setHeaders(token)
			);

			let {
				data: { data: taps },
			} = await reportInstance.post("/extra-reports/pullFraudulentCardTaps",
				{
					"max_taps": parseInt(maxTaps),
					"to_day": date.value
				}
			);
			setData(taps)

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.log(error)
		}
		setShowFilterDialog(false)
		setReportLoad(false)
	}

	useEffect(() => {
		filter_report();
	}, [])

	let formattedData = useMemo(() => {
		let returnable = [];
		for (let item of data) {
			returnable.push([
				item.card,
				item.company_name,
				item.names,
				item.tap_date,
				item.tap_location,
				item.total_tap
			])
		}

		return returnable;
	}, [data, date.value])

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div>
				<div className={styles.root}>
					<Box
						display={'flex'}
						justifyContent={'space-between'}
						paddingBottom={'40px'}
					>
						<Typography variant='h5' color='default'>
							<b>Fraudulent Card Taps</b>
						</Typography>

						<Button
							onClick={() => setShowFilterDialog(true)}
							color='primary'
							variant='contained'
						>
							Filter
						</Button>
					</Box>

					<TableView
						loading={isLoading}
						data={formattedData}
						date={date}
						maxTaps={maxTaps}
					/>
				</div>

				<Dialog
					maxWidth='sm'
					fullWidth
					open={showFilterDialog}
					onClose={() => {
						setShowFilterDialog(false);
					}}
					aria-labelledby='filter'
					aria-describedby='filter'
				>
					<DialogTitle id='filter'>{'Filter'}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box mt={1}>
									<TextField
										label='Max Taps'
										type='number'
										variant='outlined'
										defaultValue={maxTaps}
										onChange={(v) => setMaxTaps(parseInt(v.target.value))}
									/>
								</Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant='inline'
										format='yyyy-MM-dd'
										margin='dense'
										autoOk
										label='date'
										value={date.value}
										inputVariant='outlined'
										onChange={(v) => {
											setDate({
												value: Format(v, ['yyyy-MM-dd']),
												error: '',
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>

					<DialogActions>
						<Button
							onClick={() => {
								setShowFilterDialog(false);
							}}
							color='secondary'
						>
							<Typography>Close</Typography>
						</Button>

						<Button
							onClick={() => {
								filter_report();
							}}
							color='primary'
							variant='contained'
						>
							{reportLoad ? (
								<CircularProgress size={25} color='secondary' />
							) : (
								<Typography>View</Typography>
							)}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</MuiPickersUtilsProvider>
	);
}